// extracted by mini-css-extract-plugin
module.exports = {"playerContainer":"AudioPlayer_playerContainer__1uQfa"};